(function dynamicControlDirectiveDefinition() {
    'use strict';

    angular.module('CustomControls', ['CustomControlText', 'CustomControlDate', 'CustomControlNumber', 'CustomControlCombo', 'CustomControlComboKeyValue', 'CustomControlComboKeyValueMultiple', 'CustomControlComboMultiple',
        'CustomControlUser', 'CustomControlMaskedText', 'CustomControlCurrency', 'CustomControlPassword', 'CustomControlPasswordConfirm', 'CustomControlRadio',
        'CustomControlEmail', 'CustomControlPeriod', 'CustomControlBool', 'angucomplete-alt', 'angucompleteExtend', 'SystemTranslateFilter'])
        .directive('dynamicControl', [
            '$compile',
            function ($compile) {
                return {
                    restrict: 'E',
                    require: ['^form'],
                    scope: {
                        data: '=',
                        parentfun: '&',
                        controlchange: '&',
                        ouId: '@'
                    },
                    link: function (scope, element, attrs, ctrls) {

                        var template,
                            formCtrl = ctrls[0];
                        switch (attrs.type.toLowerCase()) {
                            case 'bool':
                                template = 'dynamic-bool';
                                break;
                            case 'date':
                                template = 'dynamic-date';
                                break;
                            case 'number':
                            case 'integer':
                                template = 'dynamic-number';
                                break;
                            case 'combo':
                                template = 'dynamic-combo';
                                break;
                            case 'combokv':
                                template = 'dynamic-combo-key-value';
                                break;
                            case 'usercontrol':
                                template = 'dynamic-user';
                                break;
                            case 'maskedtext':
                            case 'masked':
                                template = 'dynamic-masked-text';
                                break;
                            case 'period':
                                template = 'dynamic-period';
                                break;
                            case 'currency':
                                template = 'dynamic-currency';
                                break;
                            case 'password':
                                template = 'dynamic-password';
                                break;
                            case 'passwordconfirm':
                                template = 'dynamic-password-confirm';
                                break;
                            case 'email':
                                template = 'dynamic-email';
                                break;
                            case 'radio':
                                template = 'dynamic-radio';
                                break;
                            default:
                                template = 'dynamic-text';
                        }

                        if (scope.data.metadataIsMultivalue) {
                            template = template + '-multiple';
                        }

                        scope[formCtrl.$name] = scope.$parent[formCtrl.$name];
                        var innerElement = document.createElement(template);

                        scope.tabIndex = parseInt(attrs.tabindex || '0', 10);
                        element.append(innerElement);
                        $compile(innerElement)(scope);

                        scope.control = function (value) {
                            return scope.controlchange({ $value: value });
                        }
                    }
                };
            }
        ]);

    angular.module('CustomControls')
      .directive('dynamicFilterControl', [
          '$compile',
          function ($compile) {
              return {
                  restrict: 'E',
                  require: ['^form'],
                  scope: {
                      data: '=',
                      parentfun: '&'
                  },

                  link: function (scope, element, attrs, ctrls) {
                      var template,
                      formCtrl = ctrls[0];
                      switch (attrs.type.toLowerCase()) {
                          case 'bool':
                              template = 'dynamic-filter-bool';
                              break;
                          case 'date':
                              template = 'dynamic-filter-date';
                              break;
                          case 'number':
                          case 'integer':
                              template = 'dynamic-filter-number';
                              break;
                          case 'combo':
                              template = 'dynamic-filter-combo';
                              break;
                          case 'combokv':
                              template = 'dynamic-filter-combo-key-value';
                              break;
                          case 'userControl':
                              template = 'dynamic-filter-user';
                              break;
                          case 'currency':
                              template = 'dynamic-filter-currency';
                              break;
                          case 'maskedtext':
                          case 'masked':
                              template = 'dynamic-filter-masked-text';
                              break;
                          case 'period':
                              template = 'dynamic-filter-period';
                              break;
                          case 'password':
                              template = 'dynamic-filter-password';
                              break;
                          case 'passwordconfirm':
                              template = 'dynamic-filter-password-confirm';
                              break;
                          case 'email':
                              template = 'dynamic-filter-email';
                              break;
                          default:
                              template = 'dynamic-filter-text';
                      }

                      if (scope.data.metadataIsMultivalue) {
                          template = template + '-multiple';
                      }

                      scope[formCtrl.$name] = scope.$parent[formCtrl.$name];
                      var innerElement = document.createElement(template);

                      scope.tabIndex = parseInt(attrs.tabindex || '0', 10);
                      element.removeAttr('tabindex');
                      element.append(innerElement);
                      $compile(innerElement)(scope);
                  }
              };
          }
      ]);
})();